/* OUAI-structure components for the Fatboy redesign: hero slider + product/tile scroller. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class ObHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.ax-hero__slide')];
      this.dots = [...this.querySelectorAll('.ax-hero__dot')];
      this.toggle = this.querySelector('.ax-hero__pause');
      this.index = 0;
      this.delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.playing = this.slides.length > 1 && this.dataset.autoplay === 'true' && !reduceMotion;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
      this.querySelector('.ax-hero__prev')?.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      this.querySelector('.ax-hero__next')?.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      this.toggle?.addEventListener('click', () => this.setPlaying(!this.playing));
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target.closest('.ax-hero__slide'));
        if (i > -1) { this.go(i); this.setPlaying(false); }
      });

      this.go(0);
      this.setPlaying(this.playing);
    }

    disconnectedCallback() { clearInterval(this.timer); }

    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((s, k) => {
        const active = k === this.index;
        s.toggleAttribute('data-active', active);
        s.setAttribute('aria-hidden', String(!active));
        s.inert = !active;
        const video = s.querySelector('video');
        if (video) active && this.playing ? video.play().catch(() => {}) : video.pause();
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', String(k === this.index)));
    }

    setPlaying(on) {
      this.playing = on;
      this.toggle?.setAttribute('aria-pressed', String(!on));
      this.toggle?.setAttribute('aria-label', on ? 'Pause slideshow' : 'Play slideshow');
      const video = this.slides[this.index]?.querySelector('video');
      if (video) on ? video.play().catch(() => {}) : video.pause();
      this.restart();
    }

    restart() {
      clearInterval(this.timer);
      if (this.playing && this.slides.length > 1) this.timer = setInterval(() => this.go(this.index + 1), this.delay);
    }
  }

  class ObScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ax-scroller__track');
      this.prev = this.querySelector('.ax-scroller__prev');
      this.next = this.querySelector('.ax-scroller__next');
      this.dotsWrap = this.querySelector('.ax-scroller__dots');
      if (!this.track) return;

      this.prev?.addEventListener('click', () => this.page(-1));
      this.next?.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.ro = new ResizeObserver(() => { this.buildDots(); this.update(); });
      this.ro.observe(this.track);
    }

    disconnectedCallback() { this.ro?.disconnect(); }

    pages() {
      const { scrollWidth, clientWidth } = this.track;
      return Math.max(1, Math.ceil((scrollWidth - 2) / clientWidth));
    }

    page(dir) {
      this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    buildDots() {
      if (!this.dotsWrap) return;
      const n = this.pages();
      if (this.dotsWrap.childElementCount === n) return;
      this.dotsWrap.innerHTML = '';
      this.dotsWrap.hidden = n < 2;
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ax-scroller__dot';
        b.setAttribute('aria-label', `Go to page ${i + 1} of ${n}`);
        b.addEventListener('click', () => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }));
        this.dotsWrap.appendChild(b);
      }
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const max = scrollWidth - clientWidth - 2;
      if (this.prev) this.prev.disabled = scrollLeft <= 2;
      if (this.next) this.next.disabled = scrollLeft >= max;
      this.toggleAttribute('data-scrollable', max > 0);
      if (this.dotsWrap) {
        const current = scrollLeft >= max ? this.pages() - 1 : Math.round(scrollLeft / clientWidth);
        [...this.dotsWrap.children].forEach((d, i) => d.setAttribute('aria-current', String(i === current)));
      }
    }
  }

  if (!customElements.get('ax-hero')) customElements.define('ax-hero', ObHero);
  if (!customElements.get('ax-scroller')) customElements.define('ax-scroller', ObScroller);
})();
